import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import List from "@material-ui/core/List";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { User } from "../../../graphql/baseTypes";
import { LoadingIndicator } from "../../Loading";
import Loader from "../../Loading/Loader";
import UserListItem from "./UserListItem";

interface Props {
  items: Array<User>;
  changeUserRoles: (username: string) => any;
  loading?: boolean;
  changeUserState: (username: string, state: "Enabled" | "Disabled") => any;
  changeUserPassword: (username: string) => any;
}

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 20,
    width: "100%",
    padding: "20px 10px",
  },
}));

const UserList: React.FC<Props> = ({
  items = [],
  loading,
  changeUserRoles,
  changeUserState,
  changeUserPassword,
}) => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <Grid container>
        <Grid item xs={4}>
          <Typography variant="h5">Benutzername</Typography>
        </Grid>
        <Grid item xs={4} container justify="center">
          <Typography variant="h5">Rollen</Typography>
        </Grid>
        <Grid item xs={4} container justify="flex-end">
          <Typography variant="h5">Status</Typography>
        </Grid>
      </Grid>
      <List component="ul" aria-label="primary clientlist">
        {items.length === 0 && !loading && <h5>Keine Benutzer gefunden</h5>}
        {loading && <Loader />}
        {!loading && (
          <InfiniteScroll
            dataLength={items.length} //This is important field to render the next data
            loader={<LoadingIndicator />}
            next={() => {}}
            hasMore={false}
          >
            {items.map((item, index) => {
              return (
                <UserListItem
                  item={item}
                  key={index}
                  changeUserState={changeUserState}
                  changeUserPassword={changeUserPassword}
                  changeUserRoles={changeUserRoles}
                  isLast={index === items.length - 1}
                />
              );
            })}
          </InfiniteScroll>
        )}
      </List>
    </Paper>
  );
};

export default UserList;
